export default __webpack_public_path__ + "9ccd412c263f177bfc0fb029a955f314.svg";